
import { TDataWallet, TGetValueFromRatio, TRatiosCarterasData, TTableDataProps } from "../types/CarteraRatioTypes";
import { TOOLTIP_LINEAR_RETURN, TOOLTIP_VOLATILITY, TOOLTIP_MAX_DRAWDOWN, TOOLTIP_DOWNSIDE_DEVIATION, TOOLTIP_TIME_TO_RECOVERY, TOOLTIP_OMEGA, TOOLTIP_SHARPE, TOOLTIP_CALMAR, TOOLTIP_SORTINO } from "./texts";


export const TableData = (props: TTableDataProps) => {

    const getValueFromRatio = ({ period, ratioType, multiply, percentage } : TGetValueFromRatio) : string[] => {
        if (!props.ratios) {
            return [];
        }
        const carteraDBModelsList = props?.ratios.map((carteraData: TRatiosCarterasData) => {
            const result = carteraData.data.find(row => row.period === period && row.ratio === ratioType)
            if (result?.valueCartera) {
                const value =  multiply ? result.valueCartera * 100 : result.valueCartera
                return (ratioType === "time_to_recovery" ? value : value.toFixed(2)) +
                (percentage ? '%' : '') +
                (ratioType === "time_to_recovery" ? ' semanas' : '');
            } 
            return 'ND';
        })
        
        return carteraDBModelsList
    }

    const tableData: TDataWallet[] =[
        {
            toolTipHostContent: TOOLTIP_LINEAR_RETURN,
            ratioName: 'Retorno anualizado',
            key: 'linear_return',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'linear_return', multiply: true, percentage: true }),
        },
        {
            toolTipHostContent: TOOLTIP_VOLATILITY,
            ratioName: 'Volatilidad',
            key: 'volatility',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'volatility', multiply: true, percentage: true }),
        },
        {
            toolTipHostContent: TOOLTIP_MAX_DRAWDOWN,
            ratioName: 'Mayor caída',
            key: 'max_drawdown',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'max_drawdown', multiply: true, percentage: true }),
            
        },
        {
            toolTipHostContent: TOOLTIP_DOWNSIDE_DEVIATION,
            ratioName: 'Downside risk',
            key: 'downside_deviation',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'downside_deviation', multiply: true, percentage: true }),
        },
        {
            toolTipHostContent: TOOLTIP_TIME_TO_RECOVERY,
            ratioName: 'Tiempo de recuperación',
            key: 'time_to_recovery',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'time_to_recovery', multiply: false, percentage: false }),
        },
        {
            toolTipHostContent: TOOLTIP_OMEGA,
            ratioName: 'Omega',
            key: 'omega',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'omega', percentage: false, }),
        },
        {
            toolTipHostContent: TOOLTIP_SHARPE,
            ratioName: 'Sharpe',
            key: 'sharpe',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'sharpe', percentage: false }),
        },
        {
            toolTipHostContent: TOOLTIP_CALMAR,
            ratioName: 'Calmar',
            key: 'calmar',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'calmar', percentage: false }),
        },
        {
            toolTipHostContent: TOOLTIP_SORTINO,
            ratioName: 'Sortino',
            key: 'sortino',
            data: getValueFromRatio({ period: props.tablePeriod, ratioType: 'sortino', percentage: false }),
        },
    ]

    return tableData;
}